export { default } from "./errorPanel/errorPanel";
export { default as ErrorPage } from "./page";
